module.exports = __webpack_public_path__ + "static/img/sw.b007827c.jpg";